"use client";

import React from 'react';

export default function WhyHeliumSection() {
  return (
    <section className="relative py-32 bg-deep-dark overflow-hidden">
      {/* Background accent */}
      <div 
        className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full pointer-events-none opacity-20"
        style={{
          background: "radial-gradient(ellipse 60% 50% at 50% 50%, rgba(91, 46, 255, 0.3) 0%, transparent 70%)"
        }}
      />

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Large minimal typography statement */}
          <h2 
            className="font-heading font-bold text-text-primary mb-8 leading-tight"
            style={{
              fontSize: "clamp(36px, 5vw, 64px)",
              letterSpacing: "-0.015em"
            }}
          >
            The problem isn't China.{" "}
            <span className="text-text-secondary">It's execution.</span>
            <br />
            <span 
              className="inline-block mt-4"
              style={{
                background: "linear-gradient(135deg, #5530E6 0%, #7047E6 50%, #9370D9 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}
            >
              We're different.
            </span>
          </h2>

          <p className="text-xl text-text-secondary max-w-2xl mx-auto leading-relaxed">
            Helium is European-operated and Shenzhen-based — built on structured processes, clear communication, and operational precision. Factory-level speed with Western standards and full transparency across every shipment.
          </p>
        </div>
      </div>
    </section>
  );
}